import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { Tooltip, type SxProps, Typography, Stack } from '@mui/material';

// Marker styles
const markerStyles = {
    position: 'absolute',
    top: '2px', // Adjust vertical position
    width: '2px',
    height: '10px',
    transform: 'translateX(-50%)', // Center the marker on its position
};

interface Marker {
    position: number;
    label: string;
    color: string;
}

export interface LinearProgressBarWithMarkersProps {
    value: number;
    valueBuffer: number;
    markers: Marker[];
    sx: SxProps;
}

function LinearProgressBarWithMarkers({ value, valueBuffer, markers, sx }: LinearProgressBarWithMarkersProps) {
    const cappedValue = Math.min(100, value);
    return (
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ width: '100%' }}>
            <Box sx={{ position: 'relative', ...sx }}>
                <LinearProgress variant="determinate" value={cappedValue} valueBuffer={valueBuffer} color="inherit" sx={{ height: 13, borderRadius: 1 }} />
                <Box sx={{ minWidth: '35px', position: 'absolute', transform: 'translateX(-20%)', top: '-2px', left: `${Math.min(cappedValue, 90).toFixed(2)}%` }}>
                    <Typography
                        variant="body2"
                        sx={{ color: cappedValue <= 70 ? 'text.secondary' : 'text.primary', fontWeight: cappedValue > 50 ? 600 : 400 }}
                    >{`${Math.round(cappedValue)}%`}</Typography>
                </Box>
                {markers.map((marker, index) => (
                    <Tooltip key={"TT" + index} title={marker.label} placement="top" arrow>
                        <Box
                            key={index}
                            sx={{ ...markerStyles, left: `${marker.position}%`, backgroundColor: marker.color }}
                        >
                        </Box>
                    </Tooltip>
                ))}
            </Box>
        </Stack>
    );
}

export default LinearProgressBarWithMarkers;